import React, { createContext, useContext, useEffect, useState } from "react";
import { googleLogout, useGoogleLogin } from '@react-oauth/google';


import { askAiQuestion, askPeerQuestion, getUserData, googleAuthPromise, sendRecoveryEmail, userAuth, userLogout, userRegistration, googleAuthentication, updateAccount, uploadAvatar, answerQuestion, addUserAsAdmin, createNewPassword, subscribeHND, allHNDSubscribers, allTutorialSubscribers, deleteAcc, updateAnnouncement } from "./authentication.services";
import { verifySubscription } from "../documents/documents.services";


export const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {

    const [resStatus, setResStatus] = useState({
        authError: null,
        regError: null,
        passwordError: null,
        serverError: null,
        success: false,
        message: null
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState();
    const [userData, setUserData] = useState(null);
    const [token, setToken] = useState(null);
    const [subscribed, setSubscribed] = useState();
    const [hndSubscribed, setHndSubscribed] = useState();
    const [hSubscribers, setHSubscribers] = useState(0);
    const [tSubscribers, setTSubscribers] = useState(0);



    const loginUser = async (email, password) => {
        setIsLoading(true);
        try {
            const response = await userAuth(email, password);
            const res = await response.json();
            if (res.error) {
                setIsLoading(false);
                setResStatus((st) => ({ ...st, authError: res.error }));
                setIsAuthenticated(false);
                console.log({ error: res.error });
                return ({ authError: res.error });
            }
            setIsAuthenticated(true);
            setIsLoading(false);
            setResStatus((s) => ({ ...s, success: true }));
            setUserData(res.account);
            setToken(res.token);
            console.log(res);
            localStorage.setItem("token", res.token);
            window.location.href = "/";
            return;
        } catch (e) {
            setResStatus((s) => ({ ...s, serverError: e }));
            setIsLoading(false);
            console.log({ error: `Internal error on sign in: ${e}` });
        }
    }

    /** logout user */
    const logoutUser = async (token) => {
        setIsLoading(true);
        try {
            const response = await userLogout(token);
            await response.json();
            setIsAuthenticated(false);
            setIsLoading(false);
        } catch (e) {
            setResStatus((s) => ({ ...s, serverError: e }));
            setIsLoading(false);
            console.log({ error: `Internal error on sign in: ${e}` });
        }
    }

    /** user registration */
    const registerUserAccount = async (data) => {
        setIsLoading(true);
        try {
            const response = await userRegistration(data);
            const res = await response.json();
            if (res?.error) {
                setIsLoading(false);
                setResStatus((st) => ({ ...st, regError: res?.error }));
                return { ...resStatus, regError: res?.error };
            }
            const { account, message, token } = res;
            setResStatus((st) => ({ ...st, success: message, regError: null }));
            setToken(token);
            localStorage.setItem("token", token);
            setUserData(account);
            setIsLoading(false);
            return { ...resStatus, success: message, regError: null }
        } catch (e) {
            setResStatus((s) => ({ ...s, serverError: e }));
            setIsLoading(false);
            console.log({ error: `Internal error on registration: ${e}` });
        }
    }

    const authorizeUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await getUserData(token);
            const res = await response.json();
            setIsLoading(false);
            if (res.error) {
                setIsAuthenticated(false);
                setIsLoading(false);
                return;
            }
            setUserData(res.account);
            setIsLoading(false);
            //console.log(res);
            return res;
        } catch (e) {
            setResStatus((s) => ({ ...s, serverError: e }));
            setIsLoading(false);
            console.log({ error: `Internal error on authorization: ${e}` });
        }
    }

    const addUserAvatar = async (data) => {
         console.log({data});
        try {
            const response = await uploadAvatar(data);
            const res = await response.json();
           
            return res;
        } catch (error) {
            return ({ error })
        }
    }

    /** update account */
    const accountUpdate = async (data, token) => {
        try {

            let newData;
            if (data.imageFile) {
                const avatarLoad = await addUserAvatar(data);

                const avatarUrl = avatarLoad?.url;

                newData = { ...data, avatar: avatarUrl }
                console.log(newData)
            } else {
                newData = data;
            }
            const response = await updateAccount(newData, token);
            const res = await response.json();
            return (res);
        } catch (error) {
            console.log({ error });
        }
    }

    /** delete user account */
    const deleteMyAccount = async (token, username) => {
        setIsLoading(true);
        try {
            const response = await deleteAcc(token, username);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({error});
        }finally {
            setIsLoading(false);
        }
    }

    /** ask question */
    const askPeerAquestion = async (token, data) => {
        setIsLoading(true);
        try {
            const response = await askPeerQuestion(token, data);
            const res = await response.json();
            setResStatus({
                success: true,
                message: res.message
            })
            setIsLoading(false);
            return res;
        } catch (e) {
            setIsLoading(false);
            setResStatus({
                serverError: e
            })
            console.log({ error: e })
        }
    }

    /** send to Ai */
    const askNoteAi = async (token, question) => {
        setIsLoading(true);
        const aiToken = process.env.REACT_APP_AI_TOKEN;
        try {
            const response = await askAiQuestion(token, question);
            const res = await response.json();
            const qData = await askPeerAquestion(token, { question: question, "field_option": "Not given" });
            const qId = qData?.data?._id;
            console.log(qData);
            await postAnswer({ answer: res.message, question: qId, "field_option": "Not given" }, aiToken);
            setIsLoading(false);
            return res;
        } catch (e) {
            setIsLoading(false);
            console.log({ error: `Internal error: ${e}` });
        }
    }

    //send password recovery email
    const sendPassRecoveryEmail = async (email) => {
        try {
            setIsLoading(true);
            const response = await sendRecoveryEmail(email);
            const res = await response.json();
            setIsLoading(false);
            return res;
        } catch (e) {
            setIsLoading(false);
            console.log({ error: `Internal error: ${e}` });
        }
    }

    /** recover password */
    const recoverPassword = async (password, repeatedPassword, token) => {
        try {
            setIsLoading(true);
            const response = await createNewPassword(password, repeatedPassword, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error: `Internal error: ${error}` });
        } finally {
            setIsLoading(false);
        }
    }

    /**************************** Google authentication ********************************** */

    const googleAuth = async (data) => {
        try {
            const response = await googleAuthentication(data);
            const res = await response.json();
            return res;
        } catch (e) {
            console.log({ error: `Internal error: ${e}` });
        }
    }

    //google logout
    const googleAccountLogout = () => {
        googleLogout();
        setIsAuthenticated(false);
        localStorage.removeItem("gToken");
        localStorage.removeItem("token");
        setUserData(null);
    }

    const googleLogin = useGoogleLogin({
        onSuccess: async (codeResponse) => {
            const { access_token } = codeResponse;

            const response = await googleAuthPromise(access_token);
            const respData = await response.json();

            const { name, email } = respData;

            const authData = await googleAuth({
                names: name,
                email: email,
                token: access_token
            });
            if (authData?.newAccount) {
                localStorage.setItem("gToken", codeResponse?.access_token);
                localStorage.setItem("token", authData?.token);
                setToken(authData?.token);
                return;
            }
            setUserData(authData?.account);
            setToken(authData?.token);
            localStorage.setItem("gToken", codeResponse?.access_token);
            localStorage.setItem("token", authData?.token);
            setIsAuthenticated(true);
            window.location.href = "/";
            console.log({ authData });
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    const postAnswer = async (data, token) => {
        setIsLoading(true)
        try {
            const response = await answerQuestion(data, token);
            const res = await response.json();
            setIsLoading(false);
            return res;

        } catch (e) {
            console.log({ error: e })
        }
    }

    const checkUserSubscription = async (token) => {
        try {
            const response = await verifySubscription(token);
            const status = response.status;
            const res = await response.json();
            //console.log(res)
            if (status === 401) {
                setSubscribed(false);
                setHndSubscribed(false);
                return;
            }
            else if (status === 200) {
                if (res?.tutorial) {
                    setSubscribed(true);
                }
                if (res?.hndPQ) {
                    setHndSubscribed(true);
                }
                return;
            }
        } catch (e) {

        }
    }


    /** add user as admin */
    const addAsadmin = async (token, email) => {
        setIsLoading(true);
        try {
            const response = await addUserAsAdmin(token, email);
            const res = await response.json();
            setIsLoading(false);
            return res;
        } catch (error) {
            setIsLoading(false);
            console.log({ error });
        }
    }

    /** hnd subscription */
    const subScribeToHND = async (email, token) => {
        try {
            setIsLoading(true);
            const response = await subscribeHND(email, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    /** hnd subscribers */
    const hndsubscribers = async (token) => {
        try {
            const response = await allHNDSubscribers(token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        }
    }

    /** tutorial subscribers */
    const tutorialSubscribers = async (token) => {
        try {
            const response = await allTutorialSubscribers(token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        }
    }

    const announceUpdate = async (data, token) => {
        try {
            setIsLoading(true)
            const response = await updateAnnouncement(data, token);
            const resp = await response.json();
            return resp;
        } catch (error) {
           console.log({ error }); 
        }finally{
            setIsLoading(false);
        }
    }


    useEffect(() => {
        (async () => {
            const getTokenAsync = new Promise((resolve, reject) => {
                const tk = localStorage.getItem("token");
                if (tk) {
                    resolve(tk);
                } else {
                    reject("No token");
                }
            }).catch((e) => {
                console.log({ error: "Token null" });
                setIsAuthenticated(false);
            });


            const tk = await getTokenAsync;

            setToken(tk);
            if (tk) {
                const data = await authorizeUser(tk);

                const Hsubscr = await hndsubscribers(tk);
                setHSubscribers(Hsubscr);
            
                const Tsubscr = await tutorialSubscribers(tk);
                setTSubscribers(Tsubscr);
               
                if (data?.error) {
                    console.log({ error: `${data?.error}` });
                    setIsAuthenticated(false);
                    return;
                }
                else if (data) {
                    setIsAuthenticated(true);
                    setUserData(data?.account);
                }
                await checkUserSubscription(tk);
            }

        })();
        //console.log({serverUrl: env?.SERVER_URL});
    }, [isAuthenticated, token]);



    return (
        <AuthenticationContext.Provider
            value={{
                userData,
                isAuthenticated,
                resStatus,
                isLoading,
                token,
                subscribed,
                hndSubscribed,
                hSubscribers,
                tSubscribers,
                loginUser,
                logoutUser,
                registerUserAccount,
                askPeerAquestion,
                askNoteAi,
                sendPassRecoveryEmail,
                googleLogin,
                googleAccountLogout,
                accountUpdate,
                postAnswer,
                addAsadmin,
                recoverPassword,
                subScribeToHND,
                deleteMyAccount,
                announceUpdate
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    );
}

export const useAuth = () => useContext(AuthenticationContext);